import { Calendar } from '@fullcalendar/core';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import listPlugin from '@fullcalendar/list';
import bootstrap5Plugin from '@fullcalendar/bootstrap5';
import deLocale from '@fullcalendar/core/locales/de';


document.addEventListener('DOMContentLoaded', function () {
    if (typeof window.Plugins === 'undefined') {
        window.Plugins = {};
    }
    window.Plugins.Fullcalendar = {};
    window.Plugins.Fullcalendar.Calendar = Calendar;
    window.Plugins.Fullcalendar.dayGridPlugin = dayGridPlugin;
    window.Plugins.Fullcalendar.timeGridPlugin = timeGridPlugin;
    window.Plugins.Fullcalendar.listPlugin = listPlugin;
    window.Plugins.Fullcalendar.bootstrap5Plugin = bootstrap5Plugin;
    window.Plugins.Fullcalendar.deLocale = deLocale;
    larativoCalendar();
    document.addEventListener('livewire:update', function () {
        larativoCalendar();
    });
    function larativoCalendar() {

        var calendars = document.querySelectorAll('.fn-larativo-calendar:not([data-initialized])');
        calendars.forEach(function (item) {
            var component_id = item.dataset.id; // Component ID
            // console.log(item);
            // TODO: Check eval/Function --> https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/eval
            var options = Function('"use strict";return (' + (item.dataset.config || '{}') + ')')(); // Get json with js-functions
            // console.log(options);
            var calendar = new Plugins.Fullcalendar.Calendar(item, options);
            calendar.render();

            item.dataset.initialized = true;

            // Datum wählen
            document.querySelector('#calendar-datepicker-' + component_id).onchange = function () {
                var value = document.getElementById('calendar-datepicker-' + component_id).value;
                // console.log(value, (new Date(value)));
                calendar.gotoDate(new Date(value));
            };
        });
    }
});